export const MAX_FILE_SIZE = 5242880;
export const ALLOWED_EXTENSIONS = ["jpg", "jpeg", "png"];
